export default "__VITE_ASSET__dy4cnp2a__"